import { RestapiService } from '../services/restapi.service';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatAutocompleteSelectedEvent,
  MatAutocomplete,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { MatAccordion } from '@angular/material/expansion';
import { Platform } from '@angular/cdk/platform';
import amplitude from 'amplitude-js';

export interface Fruit {
  name: string;
}
/*
Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Malekar
*/
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  @ViewChild('divClick') divClick: ElementRef;
  @ViewChild('btnRiskClick') btnRiskClick: ElementRef;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  currentlyOpenedItemIndex = -1;

  @ViewChild('riskEle') riskEle: ElementRef;
  @ViewChild('tagEle') tagEle: ElementRef;
  @ViewChild('catEle') catEle: ElementRef;



  public riskTable: boolean = true;
  public tagsTable: boolean = true;
  public categoriesTable: boolean = true;
  public  instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");



  mobTable815: any = window.matchMedia("(max-width:800px)")
  mobTable768: any = window.matchMedia("(max-width:768px)")
  mobTable400: any = window.matchMedia("(max-width:400px)")
  mobTable430: any = window.matchMedia("(max-width:430px)")

  isMobile: boolean = false;

  constructor(
    private apiService: RestapiService,
    private route: ActivatedRoute,
    public googleAnalyticsService: GoogleAnalyticsService,
    public platform: Platform
  ) {
    
    
    if (this.mobTable768.matches) {
      this.riskTable = true;
      this.tagsTable = true;
      this.categoriesTable = true;

    } if (this.mobTable815.matches) {
      this.riskTable = true;
      this.tagsTable = true;
      this.categoriesTable = true;
    } if (this.mobTable400.matches) {
      this.riskTable = true;
      this.tagsTable = false;
      this.categoriesTable = false;
      this.isMobile = true;
    } if (this.mobTable430.matches) {
      this.riskTable = true;
      this.tagsTable = false;
      this.categoriesTable = false;
      this.isMobile = true;
    }


    //this.mobTable400.addListener(this.handleMobileChange);
    //this.handleMobileChange(this.mobTable400);

    /*  window.addEventListener("resize", function () {
       location.reload();
     }, false); */



  }



  handleMobileChange(e) {
    // Check if the media query is true
    if (e.matches) {
      // Then log the following message to the console
      // console.log('Media Query Matched!')
      this.riskTable = true;
      this.tagsTable = true;
      this.categoriesTable = true;

      /* (document.getElementById('riskEle') as HTMLInputElement).setAttribute("style", "display:block");
      (document.getElementById('tagEle') as HTMLInputElement).setAttribute("style", "display:none");
      (document.getElementById('catEle') as HTMLInputElement).setAttribute("style", "display:none"); */

    } else {
      //console.log('Media Query Matched not')
      this.riskTable = true;
      this.tagsTable = false;
      this.categoriesTable = false;
    }
  }




  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    location.reload();
  }

  appIdData: any;
  filters: any[] = [];
  riskDetailsList: any = [];
  relevanceDetailsList: any = [];
  tagsList: any[] = [];
  nonCiscoUsertagsList: any[] = [];
  isCiscoUser :boolean =false;
  categoryList: any[] = [];
  applicationList: any = [];
  filteredApplicationList: any = [];
  intermediateApplicationList: any = [];
  isTrue = false;
  tempVal: any[] = [];
  propVal: any;
  // filters
  riskFilter: any[] = [];
  brFilter: string[] = [];
  tagFilter: string[] = [];
  categoryFilter: string[] = [];
  searchAppFilter: string[] = [];
  searchFilters: any = {};
  riskCSSData: string[] = [
    'tag tag--state-success',
    'tag tag--state-info',
    'tag tag--state-medium',
    'tag tag--state-warning',
    'tag tag--state-danger',
  ];
  riskCSSFilter: string[] = [
    'tag status-very-low',
    'tag status-low',
    'tag status-medium',
    'tag status-high',
    'tag status-very-high',
  ];
  riskBusinessLevel: string[] = [
    'Very Low',
    'Low',
    'Medium',
    'High',
    'Very High',
  ];
  riskBusinessLevelIcon: string[] = [
    '../assets/images/risk_very_low.svg',
    '../assets/images/risk_low.svg',
    '../assets/images/risk_midum.svg',
    '../assets/images/risk_high.svg',
    '../assets/images/risk_very_high.svg',
  ];
  riskCSSNewData: string[] = [
    'tag tbtn-very-low',
    'tag tbtn-low',
    'tag tbtn-medium',
    'tag tbtn-high',
    'tag tbtn-very-high',
  ];

  searchProps: string[] = [
    'appName',
    'riskIndex',
    'productivityIndex',
    'tags',
    'category',
  ];

  selectedRow: number = -1;
  searchapplication: string;
  emptysearchapplication = false;
  applicationCount: number;
  customersObservable: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  activeIndex: any = 1;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  releaseNoteApplication: string;
  sortDirection: string = 'asc';
  isAsc: boolean = true;
  isDesc: boolean = false;
  accToggle: boolean = false;
  appIdArr: any[] = [];

  riskBuinessArr: number[] = [];
  riskbusinesscount = 0;

  hostname = window.location.hostname;
  filteredParentMap = new Map;

  applicationNamesForAuto: any[] = [];
  applicationNamesForAutoIntermidiate: any;
  lastkeydown1: number = 0;
  subscription: any;
  releaseDate : string;
  releaseNoteDatesMap = new Map();

  parentPropVal: string;
  parentMap = new Map<string, Object>();
  applicationName : string[] =[];
  applicationReleaseMap = new Map();
  isApplicationSearched = false;
  applicationReleaseName : string ='';
  applicationReleaseNameWithOutSpace : string ='';
  applicationReleaseNumber : string='';
  applicationNameArray : string[] =[];
  releaseNumberArray  : string[] =[];
  authCode: any;
  url: string='';
  start = false;
  authUserData: any;

  queryParametersMap = new Map();
  mainUrl : string ='';
  searchAppFilterLength : number = 0;

  sortObj: any = {
    appName: 'default',
    appDescription: 'default',
    riskIndex: 'default',
    productivityIndex: 'default',
  };

  counter(i: number) {
    return new Array(i);
  }

  applicationFilterCounter: number = 0;
  applicationwithmorethantwo: number = 0;
  filterNameDetails: string;
  isFilterApplied : boolean = false;

  applyFilter = (data: any, filter: any) =>
    data.filter((obj: any) =>    
      Object.entries(filter).every(([prop, find]) => { 
        this.tempVal = find as any[];
        this.propVal = obj[prop];
        
        if (prop === 'appName') {
          this.propVal += obj['appDescription'];
          this.propVal += obj['tags'];
          this.propVal += obj['category'];
        }
        if (prop === 'parentRisks' || prop === 'parentProductivities') {
          //console.log(" App name : " + obj['appName']+" prop : "+ prop +" tempVal : "+this.tempVal +" this.propVal : " + this.propVal +" obj[prop] : " + obj[prop]);

          const val1 = obj[prop].split(',');

          /*  if (val1.length > 1) {
 
             if (filter.parentRisks != undefined && !filter.parentRisks.includes(obj['riskIndex'])) {
               //console.log("prop : " + prop + " App name : " + obj['appName'] + " filter parentRisks : " + filter.parentRisks + " obj['riskIndex'] " + obj['riskIndex']);
               this.applicationFilterCounter = this.applicationFilterCounter + 1;
             }
             if (filter.parentProductivities != undefined && !filter.parentProductivities.includes(obj['productivityIndex'])) {
               //console.log("prop : " + prop + " App name : " + obj['appName'] + " filter parentProductivities : " + filter.parentProductivities + " obj['productivityIndex'] " + obj['productivityIndex']);
               //console.log("App name : " + obj['appName'])
               this.applicationFilterCounter = this.applicationFilterCounter + 1;
             }
             
             //return true;
           } */
          if (prop === 'parentProductivities') {
            return this.tempVal.includes(parseInt(obj['productivityIndex']));
          } else if (prop === 'parentRisks') {
            return this.tempVal.includes(parseInt(obj['riskIndex']));
          }
          //return this.tempVal.includes(parseInt(obj[prop]));
        }
        
        if (this.propVal!=undefined && isNaN(this.propVal)) {
          try{ 
              if(prop==="tags"){
              let test=   this.tempVal.some((val) =>
              this.propVal.split(",").map(i=>i.trim().toLowerCase()).indexOf(val.trim().toLowerCase()) !=-1
               ); 
              return test;
             }else{   
              let test=   this.tempVal.some((val) =>
              this.propVal.trim().toLowerCase().includes(val.trim().toLowerCase())
            ); 
            return test;
            }   
          }catch{
            console.log('...error..',this.propVal);
            return false;
          }
        
        } else {
          return this.tempVal.includes(obj[prop]);
        }
      })
    );


  ngOnInit(): void {
    if (!localStorage.hasOwnProperty("TOKEN")) {
      localStorage.setItem('TOKEN', '');
    }
    if (!localStorage.hasOwnProperty("TOKEN_EXPIRATION_SECONDS")) {
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS', '');
    }
    if(this.calculateTokenSeconds() > 3600){
      localStorage.setItem('TOKEN', '');
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS','');
      this.isCiscoUser=false;
      localStorage.setItem('IS_CISCO_USER', 'false');
      if (this.authCode != null && this.authCode !== '' ){
        console.log("inside autcode authenticate");
        this.authenticate();
      }
      this.authenticate();
    }
    if(isNaN(this.calculateTokenSeconds())){
      localStorage.setItem('TOKEN', '');
    }

    if(localStorage.getItem('IS_CISCO_USER')==='true'){
      this.isCiscoUser=true;
    }

    if(this.calculateTokenSeconds() < 3600){
      console.log('is cisco use calsec......',this.calculateTokenSeconds());
      this.isCiscoUser=true;
      localStorage.setItem('IS_CISCO_USER', 'true');
    }

    if (window.location.href.indexOf("home/showAllTags") > -1)
   {
    const self = this;
    self.route.queryParams.subscribe((params) => {
      self.authCode = params.code;
      if (
        self.authCode != null &&
        self.authCode !== '' &&
        localStorage.getItem('TOKEN')===''
      ){
        self.authenticate();
      } else {
        self.initMethods();   
      }
    });
   }
    

   

    if (this.route.snapshot.queryParams['appId'] != undefined) {
      this.getReleaseAppDetails();
      //console.log('this.filteredApplicationList :: ' + this.filteredApplicationList.length);
      this.autoclick();
    }else {
      this.getApplicationDetails();
    }
    this.getRiskBusinessTagsCategoryData();
    this.googleAnalyticsFunction('Home', 'Home', 'Home');
    if(window.location.href.indexOf('?') > -1  && window.location.href.indexOf("home/showAllTags") > -1){
      this.isCiscoUser=true;
      window.location.href='/home';
    }
    if(window.location.href.indexOf('?') > -1){
      amplitude.getInstance().setOptOut(false);
      amplitude.getInstance().logEvent("Page",{ "URL": window.location.href.substring(window.location.href.lastIndexOf('/'))  });
    }
    
   // amplitude.getInstance().setOptOut(true);
    amplitude.getInstance().logEvent("Home");

    //Added to select Risk by default when we are in mobile view.
    //Added by Ajay Malekar(amalekar)
    if (this.mobTable400.matches) {
      setTimeout(() => {
        this.btnRiskClick.nativeElement.click();
      }, 200);
    }
    //Added to select Risk by default when we are in mobile view.
    this.getReleaseDates();
    
  }

  initMethods() {
    //if (isNullOrUndefined(localStorage.getItem('TOKEN'))) {
      if (localStorage.getItem('TOKEN')==='') {
      //  alert("initMethods set token blanlk");
        console.log('initMethods set authcode');
      this.apiService.getAuthCodeUrlForShowAllTags().subscribe((resp) => {        
        let result: any;
        result = resp.body;
        this.url = result.message;
        this.url.slice(0, this.url.lastIndexOf("/"));
        localStorage.setItem('IS_CISCO_USER', 'true');
        window.location.href = this.url;
      });
       } 
  }

  authenticate() {
    this.start = true;
    this.apiService.getAccessTokenWithAuthCodeForShowAllTags(this.authCode).subscribe(
      (resp) => {
        let data: any;
        const start = new Date().getTime();
        data = resp.body;
        localStorage.setItem('TOKEN', data.access_token);
        localStorage.setItem('TOKEN_EXPIRATION_SECONDS', start + "");
     //   alert("set token");
        this.apiService.getUserInfo().subscribe((resp) => {
          this.authUserData = resp.body;
          localStorage.setItem('NAME', this.authUserData.fullname);
          localStorage.setItem('EMAIL', this.authUserData.email);
        });
        const self = this;
        self.start = false;
      },
      (err) => {
        this.start = false;
        console.log(err);
        if (err.status === 500) {
          alert(
            'There is a temporary Infra issue. Please try after some time/try opening the page in new browser. If still issue exists, please contact support team'
          );
        }
      }
    );

   
  }

  getReleaseAppDetails() {
    /*  console.log(
       'AppId : ' +
       this.route.snapshot.queryParams['appId'] +
       ' Deprecated : ' +
       this.route.snapshot.queryParams['deprecated']
     ); */

    this.apiService
      .getReleaseAppDetails(this.route.snapshot.queryParams['appId'])
      .subscribe((resp) => {
        this.appIdData = resp.body;
        this.applicationList = this.appIdData.applicationList;
        this.filteredApplicationList = this.appIdData.applicationList;
        this.customersObservable = new BehaviorSubject(this.applicationList);
        this.applicationCount = this.applicationList.length;
        this.releaseNoteApplication = this.appIdData.applicationList[0].appName;
        this.searchAppFilter.push(this.releaseNoteApplication);
        //console.log('AppName : ' + this.releaseNoteApplication);
      });
  }

  showAllTags(){
       window.location.href='/home/showAllTags';
  }

  calculateTokenSeconds() {
    var startDate = localStorage.getItem('TOKEN_EXPIRATION_SECONDS');//1662020766029
    // Do your operations
    var endDate = new Date();
    var seconds = (endDate.getTime() - parseInt(startDate)) / 1000;
    return seconds;
  }

  getRiskBusinessTagsCategoryData() {
    this.apiService.getAppIdFiltersResponse(this.appIdArr).subscribe((resp) => {
      this.appIdData = resp.body;
      this.riskDetailsList = this.appIdData.riskDetailsList;
      this.relevanceDetailsList = this.appIdData.relevanceDetailsList;
      this.tagsList = this.appIdData.tagsAndCategoryList;
      this.tagsList.sort((a,b) => a.name.localeCompare(b.name));
      console.log(...'iscisciuser....',this.isCiscoUser);
      this.nonCiscoUsertagsList=this.tagsList.filter(x=> !x.name.startsWith('Certification'));
      this.riskbusinesscount =
        this.relevanceDetailsList.length > this.riskDetailsList.length
          ? this.relevanceDetailsList.length
          : this.riskDetailsList.length;

      this.riskBuinessArr = Array.from(Array(this.riskbusinesscount).keys());
      /* console.log('this.riskDetailsList : ' + this.riskDetailsList);
      console.log('this.relevanceDetailsList : ' + this.relevanceDetailsList);
      console.log('this.tagsList : ' + this.tagsList);
      console.log('this.riskbusinesscount : ' + this.riskbusinesscount);
      console.log("arr : " + this.riskBuinessArr); */
    });
  }

  getApplicationDetails() {
    this.apiService.getAppIdDataResponse().subscribe((resp) => {
      this.appIdData = resp.body;
      this.applicationList = this.appIdData.applicationList;
      this.filteredApplicationList = this.appIdData.applicationList;
      this.customersObservable = new BehaviorSubject(this.applicationList);
      //this.sortBy('appName', false);
      this.sortBy('parentName', false);
      this.applicationCount = this.applicationList.length;
      this.getParentId();
      this.getApplicationName();
      
      if(this.route.snapshot.queryParamMap.keys.length>0){
        this.executeQueryParameterFilters();
      }
      
     
    });
  }

  googleAnalyticsFunction(actionName: string, eventName: string, eventLabel: string) {

    this.googleAnalyticsService.eventEmitter(
      actionName,      //eventName -> Partner Help
      'Menu',       //evtCategory ->Menu
      eventName,    //evtAction -> Sales
      eventLabel, //evtLabel -> Partner Help
      1           //evtValue
    );
  }

  sortDirectionCss(propName: string) {
    for (const key in this.sortObj) {
      if (key === propName) {
        this.sortObj[key] = this.sortDirection;
      } else {
        this.sortObj[key] = 'default';
      }
    }

    /* Object.entries(this.sortObj).forEach(
      ([key, value]) => { console.log(key, value);
        if(key===propName){
          this.sortObj[ke] = this.sortDirection;
        }
      }
    ); */
  }

  sortBy(
    prop: 'parentName' | 'appName' | 'appDescription' | 'riskIndex' | 'productivityIndex', dir: boolean
  ) {
    this.sortDirectionCss(prop);

    let sortOrder = 0;

    if (dir) {
      if (this.sortDirection === 'desc') {
        sortOrder = -1;
        this.sortDirection = 'asc';
      } else {
        sortOrder = 1;
        this.sortDirection = 'desc';
      }
    } else {
      sortOrder = 1;
    }


    //console.log('In sort : ' + prop);
    //this.customersObservable.next(this.applicationList.map((s : any) => ({ ...s })).sort((a : any, b : any) => {
    this.customersObservable.next(
      this.filteredApplicationList
        .map((s: any) => ({ ...s }))
        .sort((a: any, b: any) => {
          let aProp = a[prop],
            bProp = b[prop];
            
          if (isNaN(aProp) && isNaN(bProp)) {
            aProp = aProp.toLowerCase();
            bProp = bProp.toLowerCase();
          }

          if (aProp < bProp) {
            return -1 * sortOrder;
          } else if (aProp > bProp) {
            return 1 * sortOrder;
          }
          return 0;
        })
    );
  }

  addFilter(filterValue: any, filterName: any) {
    this.isFilterApplied =true;
    let analyticApiValue: string = '';
    this.filterNameDetails = filterName;
    this.linkedHoverCopiedText = 'Copy Link';
   
    // this.googleAnalyticsService.eventEmitter("Dashboard", "search", "search?q="+filterValue, 1);

    if (filterName === 'Risk') {
      analyticApiValue = this.getRiskLevel(filterValue);
    } else if (filterName === 'Business Relevance') {
      analyticApiValue = this.getRelevance(filterValue);
    }

    this.googleAnalyticsService.eventEmitter(
      filterName === 'search' ? 'Freeform' : filterName,
      'Search',
      filterName,
      filterName === 'Risk' || filterName === 'Business Relevance'
        ? analyticApiValue
        : filterValue,
      1
    );

    

    if(filterName === 'search' && filterValue.length==1){
      console.log('filterValue is null....... : ' + filterValue);
    }else{
      amplitude.getInstance().logEvent("Search",{ "Filter Name": filterName === 'search' ? 'Freeform' : filterName, 
      "Filter Value": filterName === 'Risk' || filterName === 'Business Relevance'
      ? analyticApiValue
      : filterValue }); 
    }

    
  
    
    if (
      filterName === 'search' &&
      !this.searchAppFilter.includes(filterValue) &&
      filterValue != null &&
      filterValue != '' &&
      filterValue != ' '
    ) {
            
      this.searchAppFilter.push(filterValue);
      if (!this.searchFilters.hasOwnProperty('appName')) {
        this.searchFilters.appName = this.searchAppFilter;
      }
      this.getApplicationReleaseNumberDetails(filterValue.trim());
      
    }

    /* if (filterName === 'Risk' && !this.riskFilter.includes(filterValue)) {
      this.riskFilter.push(filterValue);
      if (!this.searchFilters.hasOwnProperty('riskIndex')) {
        this.searchFilters.riskIndex = this.riskFilter;
      }
    }
    if (
      filterName === 'Business Relevance' &&
      !this.brFilter.includes(filterValue)
    ) {
      this.brFilter.push(filterValue);
      if (!this.searchFilters.hasOwnProperty('productivityIndex')) {
        this.searchFilters.productivityIndex = this.brFilter;
      }

    } */

    if (filterName === 'Risk' && !this.riskFilter.includes(filterValue)) {
      this.riskFilter.push(filterValue);
      if (!this.searchFilters.hasOwnProperty('parentRisks')) {
        this.searchFilters.parentRisks = this.riskFilter;
      }
    }
    if (
      filterName === 'Business Relevance' &&
      !this.brFilter.includes(filterValue)
    ) {
      this.brFilter.push(filterValue);
      if (!this.searchFilters.hasOwnProperty('parentProductivities')) {
        this.searchFilters.parentProductivities = this.brFilter;
      }

    }

    if (filterName === 'tag' && !this.tagFilter.includes(filterValue)) {
      this.tagFilter.push(filterValue);
      if (!this.searchFilters.hasOwnProperty('tags')) {
        this.searchFilters.tags = this.tagFilter;
      }

    }
    if (
      filterName === 'category' &&
      !this.categoryFilter.includes(filterValue)
    ) {
      this.categoryFilter.push(filterValue);
      if (!this.searchFilters.hasOwnProperty('category')) {
        this.searchFilters.category = this.categoryFilter;
      }
    }
    //console.log("Risk Filter : " + this.riskFilter);
    //console.log("BR Filter : " + this.brFilter);
    this.executeFilter();
    this.searchapplication = ' ';
    
    this.searchAppFilterLength = Object.keys(this.searchFilters).length;
    if(this.searchAppFilterLength > 0 ){
      this.createFilterUrl();  
    }


  }
  // To remove all filters;
  removeFilter() {
    this.appIdArr = [];
    this.filteredApplicationList = this.applicationList;
    this.searchFilters = {};
    this.riskFilter = [];
    this.brFilter = [];
    this.tagFilter = [];
    this.categoryFilter = [];
    this.searchAppFilter = [];
    this.searchapplication = '';
    this.emptysearchapplication = false;

    this.customersObservable = new BehaviorSubject(this.applicationList);
    this.applicationCount = this.applicationList.length;

    //Added when we clear all filters
    this.getApplicationDetails();
    this.getRiskBusinessTagsCategoryData();
    //Added when we clear all filters
    this.applicationFilterCounter = 0;
    this.isFilterApplied = false;
    this.applicationNameArray = [];
    this.applicationReleaseName ='';
    this.mainUrl='';
    this.searchAppFilterLength=0;
    this.linkedHoverCopiedText = 'Copy Link';
  }

  // to remove specific filter
  removeParticularFilter(arrayValue: any, arrayName: any, prop: string) {
    //console.log('this.applicationNameArray : ' + this.applicationNameArray.length);
    this.linkedHoverCopiedText = 'Copy Link';
    if(prop==='appName'){
      if(this.applicationNameArray.length>0){
        for (var i = 0; i < this.applicationNameArray.length; i++) {
          if (this.applicationNameArray[i].toLowerCase() === arrayValue.toLowerCase().trim()) {
            this.applicationNameArray.splice(i, 1);
          }
        }
        this.applicationReleaseName = this.applicationNameArray[this.applicationNameArray.length-1];
        this.applicationReleaseNameWithOutSpace = this.applicationNameArray[this.applicationNameArray.length-1];
        if(this.applicationNameArray.length===0){
          this.applicationReleaseName = '';
        }
      } 
      this.getApplicationReleaseNumber(this.applicationReleaseName);     
    }

    this.applicationFilterCounter = 0;
    if (
      arrayName.length === 1 &&
      arrayName.toString().includes(this.releaseNoteApplication)
    ) {

      /*  console.log(
         'Contains Deprecated : ' + arrayName.toString().includes('Deprecated')
       );
       console.log('Length : ' + (arrayName.length === 1)); */
      //Added when we clear all filters
      this.getApplicationDetails();
      this.getRiskBusinessTagsCategoryData();
      //Added when we clear all filters
    }

    arrayName.forEach((item: any, index: any) => {
      if (arrayValue === item) {
        arrayName.splice(index, 1);
      }
    });
    if (prop in this.searchFilters && !this.searchFilters[prop].length) {
      delete this.searchFilters[prop];
    }

    if (
      Object.keys(this.searchFilters).length === 0 &&
      this.searchFilters.constructor === Object
    ) {
      this.searchapplication = '';
      this.mainUrl='';
      this.linkedHoverCopiedText = 'Copy Link';
      
    }
    
    
    if(Object.keys(this.searchFilters).length === 0){
      this.isFilterApplied = false;
      this.mainUrl='';
      console.log('2');
      
    }
    
    //console.log('this.isFilterApplied : '+this.isFilterApplied);
    this.executeFilter();
    this.searchAppFilterLength = Object.keys(this.searchFilters).length;
    if(this.searchAppFilterLength > 0 ){
      this.createFilterUrl();  
    }
    
  }
  originalMap = new Map;
  executeFilter() {
    this.applicationFilterCounter = 0;
    this.toggleAccordian(this.selectedRow);


    this.filteredApplicationList = this.applyFilter(
      this.applicationList,
      this.searchFilters
    );

    /*  this.customersObservable = new BehaviorSubject(
       this.filteredApplicationList
     ); */

    let filterApplicationCount = 0;
    filterApplicationCount = this.filteredApplicationList.length;
    let myMap = new Map();

    //add parent details in myMap.
    for (var app of this.filteredApplicationList) {
      if (this.parentMap.get(app['parentId']) != undefined) {
        if (this.parentMap.get(app['parentId']) != null) {
          myMap.set(app['parentId'], this.parentMap.get(app['parentId']));
        }
      }
    }
    //delete any child details from myMap
    myMap.delete(undefined);
    for (let app of this.filteredApplicationList) {
      if (myMap.get(app['appId'])) {
        myMap.delete(app['appId']);
      }
    }
    //this.filteredParentMap = myMap;
    //console.log(this.filteredParentMap);
    
    for (let entry of myMap.keys()) {
      let dataObj = new Object();
      dataObj = myMap.get(entry);
      let io = {

        "appId": dataObj['appId'],
        "appName": dataObj['appName'],
        "appName1": dataObj['appName1'],
        "appDescription": dataObj['appDescription'],
        "riskIndex": dataObj['riskIndex'],
        "productivityIndex": dataObj['productivityIndex'],
        "tags": dataObj['tags'],
        "category": dataObj['cateogry'],
        "protocol": dataObj['protocol'],
        "parentId": dataObj['parentId'],
        "parentName": dataObj['parentName'],
        "parentRisks": dataObj['parentRisks'],
        "parentProductivities": dataObj['parentProductivities']

      };
      if ( !this.originalMap.has(entry)) {
        this.originalMap.set(entry, io);
      }

    /* if (!this.isMobile) {        
        let dataObj1 = new Object();
        dataObj1 = myMap.get(entry);
        dataObj1['riskIndex'] = 0;
        dataObj1['productivityIndex'] = 0;
      }*/

    }
    //console.log('this.originalMap : ' + this.originalMap.size);
    //add parent details from myMap in filteredApplicationList
    
    for (let entry of myMap.keys()) {
      //this.filteredApplicationList.push(myMap.get(entry));
      //console.log('entry '+ entry);
      this.filteredApplicationList.unshift(myMap.get(entry));
    }

    this.customersObservable = new BehaviorSubject(this.filteredApplicationList);
    //console.log(this.customersObservable);
    //console.log(this.filteredApplicationList); 
    //********************************* */  
    /* if(this.filteredApplicationList.length - this.applicationFilterCounter<=0){
      this.applicationCount = this.filteredApplicationList.length;
    }else if(this.filteredApplicationList.length > this.applicationFilterCounter){
      this.applicationCount = this.filteredApplicationList.length - this.applicationFilterCounter ;
    }else{
      this.applicationCount = this.filteredApplicationList.length ;
    } */
    /*  if(this.filteredApplicationList.length - mySet.size<=0){
       this.applicationCount = this.filteredApplicationList.length;
     }else if(this.filteredApplicationList.length > mySet.size){
       this.applicationCount = (this.filteredApplicationList.length - mySet.size)+1 ;
     }else{
       this.applicationCount = this.filteredApplicationList.length ;
     } */
    //this.applicationCount = (this.filteredApplicationList.length - mySet.size) +1;
    if (myMap != null && myMap.size == 1) {
      this.applicationCount = filterApplicationCount + myMap.size;
    }
    this.applicationCount = filterApplicationCount;
    this.applicationFilterCounter = 0;

    //this.sortBy('appName', false);
    this.sortBy('parentName', false); //commented by amalekar to test Hierachy data.
    this.selectedRow = -1;
    //this.appIdsList();

    if (this.applicationCount === 1 && this.searchapplication != '') {
      //console.log('Auto click...');
      this.autoclick();
    }
    
    for (let originalEntry of this.originalMap.keys()) {
      
      let obj = this.originalMap.get(originalEntry);
      //console.log(obj);
      for (var i = 0; i < this.applicationList.length; i++) {
        if (this.applicationList[i].appId === obj['appId']) {
          this.applicationList.splice(i, 1);
          break;
        }
      }
    }

    for (let originalEntry of this.originalMap.keys()) {
      this.applicationList.unshift(this.originalMap.get(originalEntry));
    }
   // console.log(this.filteredApplicationList);
  }

  autoclick() {
    setTimeout(() => {
      this.divClick.nativeElement.click();
    }, 1000);
  }

  appIdsList() {
    this.appIdArr = [];
    for (var val of this.filteredApplicationList) {
      this.appIdArr.push(val.appId);
    }
    this.getRiskBusinessTagsCategoryData();
  }

  getSortingClass(prop: string) {
    return this.sortObj[prop];
  }
  getRiskCSSData(appIndex: any) {
    return this.riskCSSData[appIndex - 1];

  }
  getRiskFilterCSS(appIndex: any) {
    return this.riskCSSFilter[appIndex - 1];
  }
  getRelevanceClass(appIndex: any) {
    return this.riskCSSData[this.riskCSSData.length - appIndex];
  }
  getRiskLevel(appIndex: any) {
    return this.riskBusinessLevel[appIndex - 1];
  }
  getRiskLevelIcon(appIndex: any) {
    return this.riskBusinessLevelIcon[appIndex - 1];
  }
  getRelevance(appIndex: any) {
    return this.riskBusinessLevel[this.riskBusinessLevel.length - appIndex];
  }
  getRiskCSSDataNew(appIndex: any) {
    return this.riskCSSNewData[appIndex - 1];

  }

  toggleAccordian(index: any) {
    // let element = event.target;
    // element.classList.toggle('active');
    /* console.log(
      'selectedRow : ' +
      this.selectedRow +
      ' index : ' +
      index +
      ' accToggle : ' +
      this.accToggle
    ); */

    if (
      this.selectedRow !== -1 &&
      this.filteredApplicationList[this.selectedRow].isActive
    ) {
      if (this.selectedRow === index) {
        this.accToggle = true;
      }

      /*  console.log(
         'in if : ' + this.filteredApplicationList[this.selectedRow].isActive
       ); */

      this.filteredApplicationList[this.selectedRow].isActive = false;
      (
        document.getElementById(
          'object-' + this.selectedRow
        ) as HTMLInputElement
      ).style.display = 'none';
      (
        document.getElementById(
          'accordianbtn-' + this.selectedRow
        ) as HTMLInputElement
      ).className = 'accordion__toggle icon-chevron-right';
      (
        document.getElementById(
          'applicationrowdata-' + this.selectedRow
        ) as HTMLInputElement
      ).setAttribute("style", "background-color:''; color:''; ");
      //.style.backgroundColor = '';
    } else {
      this.accToggle = false;
    }
    if (
      this.selectedRow !== index ||
      (!this.accToggle && this.selectedRow !== -1)
    ) {
      //console.log('in -1=0 ');
      this.accToggle = false;
      this.filteredApplicationList[index].isActive = true;
      (
        document.getElementById('object-' + index) as HTMLInputElement
      ).style.display = '';
      (
        document.getElementById('accordianbtn-' + index) as HTMLInputElement
      ).className = 'accordion__toggle icon-chevron-down activeRow';
      (
        document.getElementById(
          'applicationrowdata-' + index
        ) as HTMLInputElement
        //).setAttribute("style", "background-color:#2C6C98; color:#fff; ");
      ).setAttribute("style", "background-color:#EBFAFF; color:#000000; ");//change by amalekar
      //.style.backgroundColor = '#2C6C98';

    }
    this.selectedRow = index;
  }
  toggleSingle(resSize: number, rowIndex: number) {

    if (resSize === 1) {
      this.toggleAccordian(rowIndex);
    }

  }

  setOpened(itemIndex) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  showRisk() {
    this.riskTable = true;
    this.tagsTable = false;
    this.categoriesTable = false;
    this.activeIndex = 1;
  }

  showTags() {
    this.riskTable = false;
    this.tagsTable = true;
    this.categoriesTable = false;
    this.activeIndex = 2;
  }

  showCategories() {
    this.riskTable = false;
    this.tagsTable = false;
    this.categoriesTable = true;
    this.activeIndex = 3;
  }


  @HostListener('scroll', ['$event'])
  scrollHandler(event) {

  }

  //---------------------------------------
 
  getParentId() {
    for (var app of this.applicationList) {

      this.parentMap.set(app['appId'], app);
    }
  }
  getApplicationName() {
    for (var app of this.applicationList) {
      var appName = app['appName'];
      appName = appName.split('::');
      if(appName[1]!=undefined){
        this.applicationName.push(appName[1]);
      }else{
        this.applicationName.push(appName[0]);
        this.applicationNamesForAuto.push(appName[0]);
      }
      
    }
    //console.log(this.applicationName);
  }
  getApplicationReleaseNumber(applicatioName : string){
    
    if(applicatioName!=undefined && applicatioName!=''){
      if(this.applicationReleaseMap.has(applicatioName.toLowerCase().trim())){
        this.releaseNumberArray =this.applicationReleaseMap.get(applicatioName.toLowerCase().trim()).split(",");
      }     
      console.log('.......',this.releaseNumberArray );
      //return  this.applicationReleaseMap.get(applicatioName.toLowerCase().trim());
    }    
  }
  getApplicationReleaseNumberDetails(filterValue : string){
    this.applicationReleaseNumber ='';
    this.applicationReleaseName ='';
    this.applicationReleaseNameWithOutSpace ='';
    var applicatioNameExists = false;
   // console.log('getApplicationReleaseNumberDetails : filterValue : ' + filterValue);
      for (var app of this.applicationName) {
       // console.log(app.toUpperCase()===filterValue.toUpperCase().trim());
        if (app.toUpperCase().trim()===filterValue.toUpperCase().trim()) {
          this.applicationReleaseName = app;
          this.applicationReleaseNameWithOutSpace = app;
          applicatioNameExists = true;
          break;
        }
      }
      if(!applicatioNameExists){
        this.applicationReleaseNameWithOutSpace = filterValue;
        this.applicationReleaseName = filterValue;
        this.applicationNameArray.push(filterValue);
      }
      if(!this.applicationNameArray.includes(this.applicationReleaseName) && applicatioNameExists){
        this.applicationNameArray.push(this.applicationReleaseName);
        
      }
      
      if(filterValue.toLowerCase().startsWith('cve-')){
        this.applicationReleaseName = filterValue.toLowerCase().replace('cve-','cve ');
        //console.log('startsWith cve- '+ this.applicationReleaseName.replace('cve-','cve '));
      }
        
        this.apiService.getReleaseNumberForApp(this.applicationReleaseName).subscribe((resp) => {
        this.applicationReleaseNumber = JSON.parse(JSON.stringify(resp.body)).message;
        //console.log('applicationReleaseName '+ this.applicationReleaseName +' release number : '+this.applicationReleaseNumber +' applicatioNameExists : '+applicatioNameExists);
        if(!applicatioNameExists && this.applicationReleaseNumber!='0'){
          this.applicationReleaseMap.set(filterValue.toLowerCase(),this.applicationReleaseNumber);
          
        }else if(!this.applicationReleaseMap.has(this.applicationReleaseName.toLowerCase())&& this.applicationReleaseNumber!='0'){
          this.applicationReleaseMap.set(this.applicationReleaseName.toLowerCase(),this.applicationReleaseNumber);
          
        }
        if(applicatioNameExists && this.applicationReleaseNumber.trim()!='0'){
          this.getApplicationReleaseNumber(this.applicationReleaseName);
        }else if(!applicatioNameExists && this.applicationReleaseNumber.trim()!='0'){
          this.getApplicationReleaseNumber(filterValue);
        }
        
        if(this.applicationReleaseNumber.trim()==='0'){
          for( var i = 0; i < this.applicationNameArray.length; i++){     
            if ( this.applicationNameArray[i] === this.applicationReleaseName) {         
              this.applicationNameArray.splice(i, 1);
              break; 
            } 
            
        }
        this.applicationReleaseNameWithOutSpace = this.applicationNameArray[this.applicationNameArray.length-1];       
        }
        
        //console.log(this.applicationReleaseMap);
        //console.log(this.applicationNameArray);
        
        this.applicationReleaseName = this.applicationReleaseName.replace(/ /g, '');
      });
  }
 

  

  getUserIdsFirstWay($event) {
    (document.getElementById('autoPopAppDropdown') as HTMLInputElement).style.display = 'block';
    let userId = (<HTMLInputElement>document.getElementById('searchinputtext')).value;
    this.applicationNamesForAutoIntermidiate = [];
    console.log(userId);
    if (userId.length > 2) {
      if ($event.timeStamp - this.lastkeydown1 > 200) {
        this.applicationNamesForAutoIntermidiate = this.searchFromArray(this.applicationNamesForAuto, userId);
      }
    }
  }  

  searchFromArray(arr, regex) {
    let matches = [], i;
    for (i = 0; i < arr.length; i++) {
      let data = arr[i];
      
      if (data.toLowerCase().match(regex.trim().toLowerCase())) {
        if(!matches.includes(data)){
          matches.push(data);
        }        
      }
    }
    return matches;
  };
  HideAutoPopulate(){
    console.log('Hide');
    (document.getElementById('autoPopAppDropdown') as HTMLInputElement).style.display = 'none';
    
  }
  showInfo(){
    (document.getElementById('releasenotesinfo') as HTMLInputElement).style.display = 'block';
  }
  hideInfo(){
    (document.getElementById('releasenotesinfo') as HTMLInputElement).style.display = 'none';
  }
  selectApplication(appName : string){
    this.searchapplication = appName;
    (document.getElementById('autoPopAppDropdown') as HTMLInputElement).style.display = 'none';
    
  } 
  ShowRelDates(releaseNumber : any){
    //console.log(releaseNumber);

    this.releaseDate = "Release Date: "+ this.releaseNoteDatesMap.get(releaseNumber);

  } 
  
  ngAfterViewInit() {
    /* setTimeout(() => {
      this.executeQueryParameterFilters();
    }, 3000);
     */
  } 
  getReleaseDates(){
    this.apiService.getReleaseNumberDates().subscribe((resp) => {
      
      var releaseDatesData = JSON.parse(JSON.parse(JSON.stringify(resp.body)).message);
      //console.log(releaseDatesData);
     
      for (var key in releaseDatesData) {
        if (releaseDatesData.hasOwnProperty(key)) {
          var val = releaseDatesData[key];
          this.releaseNoteDatesMap.set(key,val);
        }
      }

    });
  }

  createFilterUrl(){
    const hostname = window.location.hostname;
    let queryParameters ='';
    let protocolPostHost ='';

    if (hostname === 'localhost') {
      protocolPostHost = location.protocol+'//'+location.hostname+':'+location.port+'/home?';
    } else {
      protocolPostHost = location.protocol+'//'+location.hostname+'/home?';
    }
    
    //console.log('-------------------');
    
    this.queryParametersMap.set('&appname=',this.searchAppFilter);
    this.queryParametersMap.set('&risk=',this.riskFilter);
    this.queryParametersMap.set('&br=',this.brFilter);
    this.queryParametersMap.set('&tags=',this.tagFilter);
    this.queryParametersMap.set('&categories=',this.categoryFilter);
    
    
    protocolPostHost = protocolPostHost.concat('&appname='+this.queryParametersMap.get('&appname='));    
    protocolPostHost = protocolPostHost.concat('&risk='+this.queryParametersMap.get('&risk='));
    protocolPostHost = protocolPostHost.concat('&br='+this.queryParametersMap.get('&br='));
    protocolPostHost = protocolPostHost.concat('&tags='+this.queryParametersMap.get('&tags='));
    protocolPostHost = protocolPostHost.concat('&categories='+this.queryParametersMap.get('&categories='));
    this.mainUrl = encodeURI(protocolPostHost);
    console.log('Main URL :'+this.mainUrl);
    //navigator.clipboard.writeText(protocolPostHost).then().catch(e => console.error(e));
    //console.log('-------------------');
  }
  executeQueryParameterFilters(){
     /*  console.log('Risk : ' + this.route.snapshot.queryParams['risk']);
      console.log('Br : ' + this.route.snapshot.queryParams['br']);
      console.log('Tags : ' + this.route.snapshot.queryParams['tags']);
      console.log('Category : ' + this.route.snapshot.queryParams['categories']); */

      if (this.route.snapshot.queryParams['appname'] != undefined && this.route.snapshot.queryParams['appname'] != '') {
        let appNameParameters = this.route.snapshot.queryParams['appname'];

        if(appNameParameters.includes(',')){
          let appNameParametersArr =  appNameParameters.split(',');
          for(let appNameData of appNameParametersArr){
            this.addFilter(appNameData,'search');
          }
        }else{
          this.addFilter(this.route.snapshot.queryParams['appname'],'search');
        }

      }

      if (this.route.snapshot.queryParams['risk'] != undefined && this.route.snapshot.queryParams['risk'] != '') {
        let riskParameters = this.route.snapshot.queryParams['risk'];

        if(riskParameters.includes(',')){
          let riskParametersArr =  riskParameters.split(',');
          for(let riskData of riskParametersArr){
            this.addFilter(parseInt(riskData),'Risk');
          }
        }else{
          this.addFilter(parseInt(this.route.snapshot.queryParams['risk']),'Risk');
        }

      }
      if (this.route.snapshot.queryParams['br'] != undefined && this.route.snapshot.queryParams['br'] != '') {
        let brParameters = this.route.snapshot.queryParams['br'];

        if(brParameters.includes(',')){
          let brParametersArr =  brParameters.split(',');
          for(let brData of brParametersArr){
            this.addFilter(parseInt(brData),'Business Relevance');
          }
        }else{
          this.addFilter(parseInt(this.route.snapshot.queryParams['br']),'Business Relevance');
        }
        
      }
      if (this.route.snapshot.queryParams['tags'] != undefined &&this.route.snapshot.queryParams['tags'] != '') {
        let tagParameters = this.route.snapshot.queryParams['tags'];
        
        if(tagParameters.includes(',')){
          let tagParametersArr =  tagParameters.split(',');
          for(let tagData of tagParametersArr){
            this.addFilter(tagData,'tag');
          }
        }else{
          this.addFilter(this.route.snapshot.queryParams['tags'],'tag');
        }
        
      }
      if (this.route.snapshot.queryParams['categories'] != undefined && this.route.snapshot.queryParams['categories'] != '') {
        let categoryParameters = this.route.snapshot.queryParams['categories'];
        
        if(categoryParameters.includes(',')){
          let categoryParametersArr =  categoryParameters.split(',');
          for(let categoryData of categoryParametersArr){
            this.addFilter(categoryData,'category');
          }
        }else{
          this.addFilter(this.route.snapshot.queryParams['categories'],'category');
        }
        
      }
  }
  isLinkCopied : boolean =false;
  @ViewChild('linkClicked') linkClicked: ElementRef;
  linkedHoverCopiedText : string ='Copy Link';
  
  copyToClipboard(){
    //navigator.clipboard.writeText(this.mainUrl).then().catch(e => console.error(e));

    navigator.clipboard.writeText(this.mainUrl).then(function() {
      console.log('Link copied...');
    }, function() {
      console.log('Link copying failed...');
    });
    //this.copyTo(this.mainUrl);
    this.isLinkCopied = !this.isLinkCopied;
    this.linkedHoverCopiedText = "Copied to clipboard";
    (document.getElementById('linkClicked') as HTMLInputElement).setAttribute("class", "tooltip__text_copied");
    setTimeout(() => {
      
      //(document.getElementById('linkClicked') as HTMLInputElement).setAttribute("min-width", "100px");
      
    }, 5000);
  }
  getLinkcopiedCss(){
    if(this.linkedHoverCopiedText=== 'Copied to clipboard'){
      return 'tooltip__text_copied';
    }else{
      return 'tooltip__text';
    }
  }
   copyTo(textToCopy) {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        return navigator.clipboard.writeText(textToCopy);
    } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise<void>((res, rej) => {
            // here the magic happens
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
        });
    }
  }
}

